import React, { useState, useRef, useEffect } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    Label,
    Card,
    CardBody,
    Input
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    getData as onGetDataTable,
    clearData as onClearDataTable,
    approveAccountTransactionClient as onApproveAccountTransactionClient,
} from "../../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import DeleteModal from "../../../components/Common/ModalDelete";
import CurrencyFormat from 'react-currency-format';
import Filter from "./filter";
import DataTable from "components/Common/DataTable";
import ModalApproval from "./modalApproval";
import RejectModal from "./ModalReject";

const Approval = () => {
    //meta title
    document.title = "Approval Transaction | Client Transaction | Des Counts";
    const dispatch = useDispatch();
    const urlData = "account-transaction-client/get"
    const [isOpenApproval, setIsOpenApproval] = useState(false)
    const [isOpenReject, setIsOpenReject] = useState(false)
    const [approvalData, setApprovalData] = useState(null)
    const [triggerRefresh, setTriggerRefresh] = useState(false)
    const [messageReject, setMessageReject] = useState(false)

    const { page, pageSize } = useSelector(state => ({
        page: state.DataTable.page,
        pageSize: state.DataTable.length,
    }));

    var filterWaitingApproval = useRef(null)

    const onSubmitApproval = (data) => {
        dispatch(onApproveAccountTransactionClient({
            id : data?.id,
            companyId : data?.companyId,
            periodId : data?.periodId,
            accountId : data?.accountId,
            accountNumberId : data?.accountNumberId,
            remarks : data?.remarks,
            date : data?.date,
            type : data?.type,
            nominal : data?.nominal,
            fiscal : data?.fiscal,
            adjustment : data?.adjustment,
            approved : true,
        }, () => {
            setTriggerRefresh(!triggerRefresh)
        }))
        setIsOpenApproval(false)
    }

    const onSubmitReject = (data) => {
        dispatch(onApproveAccountTransactionClient({
            id : data?.id,
            companyId : data?.companyId,
            periodId : data?.periodId,
            accountId : data?.accountId,
            accountNumberId : data?.accountNumberId,
            remarks : data?.remarks,
            date : data?.date,
            type : data?.type,
            nominal : data?.nominal,
            fiscal : data?.fiscal,
            adjustment : data?.adjustment,
            approved : false,
        }, () => {
            setTriggerRefresh(!triggerRefresh)
        }))
        setIsOpenReject(false)
    }

    const onOpenApproval = (data) => {
        setApprovalData(data)
        setIsOpenApproval(true)
    }

    const onOpenReject = (data) => {
        setMessageReject("Transaction with remarks \"" + data?.remarks + "\" will be rejected.")
        setApprovalData(data)
        setIsOpenReject(true)
    }

    const columnData = [
        {
            key: "dateStr",
            name: "Date",
            headerClass: "text-center",
            contentClass: "text-center",
        },
        {
            key: "accountNumber.name",
            name: "Account Number",
            headerClass: "text-center",
            contentClass: "text-center",
            render: (row) => {
                return row?.accountNumber?.name ?? "";
            }
        },
        {
            key: "account.name",
            name: "Account",
            headerClass: "text-center",
            contentClass: "text-center",
            render: (row) => {
                return row?.account?.name ?? "-";
            }
        },
        {
            key: "remarks",
            name: "Remarks",
            headerClass: "text-start",
            contentClass: "text-start",
            render: (row) => {
                return row?.remarks ?? "";
            }
        },
        {
            key: "type",
            name: "Type",
            headerClass: "text-center",
            contentClass: "text-center",
            render: (row) => {
                return (row?.type ?? "-").toUpperCase();
            }
        },
        {
            key: "nominal",
            name: "Nominal",
            headerClass: "text-center",
            contentClass: "text-end",
            render: (row) => {
                return <CurrencyFormat value={row.nominal ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                    displayType={'text'} />;
            }
        },
        {
            key: "status",
            name: "Status",
            headerClass: "text-center",
            contentClass: "text-center",
            render: (row) => {
                if (row.approved === true) {

                    return <span className={"badge bg-success"}>Approved</span>;
                }
                else if (row.approved === false) {
                    return <span className={"badge bg-danger"}>Rejected</span>;
                }
                else {
                    return <span className={"badge bg-info"}>Waiting Approval</span>;
                }

            }
        },
        {
            key: "action",
            name: "Action",
            headerClass: "text-center min-width-action-155",
            contentClass: "text-center min-width-action-155",
            render: (row) => {
                if (row.approved === true || row.approved === false) {
                    return ""
                }
                else {
                    return <>
                        <Button color="success me-2" size="sm" onClick={() => {
                            onOpenApproval(row)
                        }}>Approve</Button>
                        <Button color="danger" size="sm" onClick={() => {
                            onOpenReject(row)
                        }}>Reject</Button>
                    </>;
                }

            }
        }
    ]

    const onRefreshCommand = (filter) => {
        let param = { ...filter, isWaitingApproval: filterWaitingApproval.current.checked ? true : null }
        dispatch(onGetDataTable(urlData, page, pageSize, param))
    }

    useEffect(() => {
        dispatch(onClearDataTable())
    }, [dispatch])

    return (
        <React.Fragment>
            <ModalApproval show={isOpenApproval} onSubmit={onSubmitApproval} onCancel={() => setIsOpenApproval(false)} data={approvalData} />
            <RejectModal message={messageReject} show={isOpenReject} onSubmit={() => {
                onSubmitReject(approvalData)
            }} onCancel={() => setIsOpenReject(false)} />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Client Transaction" breadcrumbItem="Approval Transaction" />
                    <Row className="mb-3">
                        <Col xs="12">
                            <Filter onSubmit={onRefreshCommand} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className="flex-grow-1">
                                            <div className="form-check ms-2 mt-2">
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-Input"
                                                    defaultChecked={true}
                                                    id={"filterWaitingApproval"}
                                                    innerRef={filterWaitingApproval}
                                                />
                                                <Label
                                                    className="form-check-label ms-1"
                                                    htmlFor={"filterWaitingApproval"}>
                                                    Only Show Waiting For Approval
                                                </Label>
                                            </div>
                                        </div>
                                    </div>
                                    <DataTable columns={columnData} url={urlData} trigger={triggerRefresh} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

Approval.propTypes = {
    className: PropTypes.string,
    preGlobalFilteredRows: PropTypes.any,
};

export default Approval
